import script from "./UserProfile .vue?vue&type=script&setup=true&lang=js"
export * from "./UserProfile .vue?vue&type=script&setup=true&lang=js"

import "./UserProfile .vue?vue&type=style&index=0&id=c6077618&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c6077618"]])

export default __exports__